;(() => {
	/**
	 * Determine slidesPerView for the element at the current breakpoint
	 * based on the same logic your Swiper config uses.
	 */
	const getSlidesPerView = (el) => {
		const isHorizontal = el.classList.contains('logo-list__content--horizontal-carousel')
		const isVertical = el.classList.contains('logo-list__content--vertical-carousel')

		// Mobile (< 750)
		if (window.matchMedia('(max-width: 749px)').matches) {
			// horizontal uses 2, others use 3 in your original code
			return isHorizontal ? 2 : 3
		}

		// 750+
		if (window.matchMedia('(min-width: 1200px)').matches) {
			if (isVertical) return 3
			return isHorizontal ? 6 : 3
		}

		if (window.matchMedia('(min-width: 990px)').matches) {
			if (isVertical) return 3
			return isHorizontal ? 4 : 3
		}

		// 750–989
		if (isVertical) return 3
		return 3
	}

	/**
	 * Ensure we have enough slides to loop smoothly.
	 * We target slidesPerView * 4 (so loop never "starves"),
	 * and clone until we hit that target or a safe max.
	 */
	const ensureEnoughSlides = (swiperEl) => {
		const wrapper = swiperEl.querySelector('.swiper-wrapper')
		if (!wrapper) return

		const originals = Array.from(wrapper.querySelectorAll('.logo-list__item'))
		if (originals.length === 0) return

		const spv = getSlidesPerView(swiperEl)
		const required = Math.min(Math.max(spv * 4, 8), 48) // at least 8, max 48

		// Clone from the ORIGINAL set only
		let currentCount = wrapper.querySelectorAll('.logo-list__item').length
		let safety = 0

		while (currentCount < required && safety < 12) {
			for (const el of originals) {
				if (currentCount >= required) break
				wrapper.appendChild(el.cloneNode(true))
				currentCount++
			}
			safety++
		}
	}

	const recalculateSlidesLength = (root) => {
		const scope = root || document
		scope.querySelectorAll('.js-slider-logos, .js-slider-logos-slow').forEach((el) => {
			ensureEnoughSlides(el)
		})
	}

	const initOneSwiper = (el) => {
		const duration = Number(el.getAttribute('data-duration')) || 4000
		const isMobile = window.matchMedia('(max-width: 749px)').matches
		const adjustedSpeed = isMobile ? Math.max(2000, Math.ceil(duration / 2)) : duration

		// Make sure we have enough slides BEFORE init
		ensureEnoughSlides(el)

		// Determine direction per breakpoint
		const isVertical = el.classList.contains('logo-list__content--vertical-carousel')

		const swiper = new Swiper(el, {
			slidesPerView: getSlidesPerView(el),
			spaceBetween: window.matchMedia('(min-width: 1200px)').matches
				? 24
				: window.matchMedia('(min-width: 990px)').matches
					? 24
					: window.matchMedia('(min-width: 750px)').matches
						? 20
						: 16,

			direction: isVertical && window.matchMedia('(min-width: 750px)').matches ? 'vertical' : 'horizontal',

			// Ticker settings
			loop: true,
			watchOverflow: false,
			speed: adjustedSpeed,

			autoplay: {
				delay: 0,
				disableOnInteraction: false,
				pauseOnMouseEnter: false,
			},

			freeMode: true,
			freeModeMomentum: false,

			allowTouchMove: false,
			simulateTouch: false,

			// Help looping stability when there are many/variable slides
			loopAdditionalSlides: 24,

			breakpoints: {
				750: {
					direction: isVertical ? 'vertical' : 'horizontal',
					slidesPerView: 3,
					spaceBetween: 20,
				},
				990: {
					direction: isVertical ? 'vertical' : 'horizontal',
					slidesPerView: el.classList.contains('logo-list__content--horizontal-carousel') ? 4 : 3,
					spaceBetween: 24,
				},
				1200: {
					direction: isVertical ? 'vertical' : 'horizontal',
					slidesPerView: el.classList.contains('logo-list__content--horizontal-carousel') ? 6 : 3,
					spaceBetween: 24,
				},
			},
		})

		// Recover if the browser throttles timers (tab switch)
		document.addEventListener('visibilitychange', () => {
			if (!document.hidden) {
				try {
					swiper.update()
					if (swiper.autoplay) swiper.autoplay.start()
				} catch (e) {}
			}
		})

		return swiper
	}

	const initSlider = (sectionRoot) => {
		const root = sectionRoot || document

		root.querySelectorAll('.js-slider-logos, .js-slider-logos-slow').forEach((el) => {
			if (el.swiper) {
				try {
					el.swiper.destroy(true, true)
				} catch (e) {}
			}
			initOneSwiper(el)
		})
	}

	const initSection = (section) => {
		const sectionLogos = document.currentScript
			? document.currentScript.parentElement
			: section

		if (!sectionLogos) return

		recalculateSlidesLength(sectionLogos)
		initSlider(sectionLogos)

		// Debounced ResizeObserver: rebuild only when width changes
		let rafId = null
		let lastWidth = Math.round(sectionLogos.getBoundingClientRect().width)

		const ro = new ResizeObserver((entries) => {
			const entry = entries && entries[0]
			if (!entry) return

			const newWidth = Math.round(entry.contentRect.width)
			if (newWidth === lastWidth) return

			lastWidth = newWidth

			if (rafId) cancelAnimationFrame(rafId)
			rafId = requestAnimationFrame(() => {
				recalculateSlidesLength(sectionLogos)
				initSlider(sectionLogos)
			})
		})

		ro.observe(sectionLogos)
	}

	initSection()

	document.addEventListener('shopify:section:load', function (evt) {
		initSection(evt.target)
	})
})()
